export default import.meta.ROLLDOWN_FILE_URL_RRA3M7I3IG_3hD1v1D9tKA